import React from 'react';
import '../../assets/css/chat.css';
import $ from 'jquery';
import { GetLiveUsers, SendEmit, GetLiveReceiver, ReconnectReceiver } from '../../SocketData'
import { ud, SERVER_IP, PORT, } from '../../Server'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
// import SocketIOFileUpload from 'socketio-file-upload';

var socket;

class Chat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user_active_list: [],
            latest_msg_list: [],
            grp_msg_list: [],
            selectedUserId: 0,
            selectedUserSection: "SINGLE",
            user_view_by: "ACTIVE",  // "MESSAGE", "ACTIVE", "GROUPBY"
            ActiveChats: [],
            msg_txt: ""
        }
    }
    componentDidMount() {
        this.streshBody()
        setTimeout(() => {
            this.getAllLiveUser();
            this.msgReceiver();
        }, 2000)
    }

    streshBody = () => {
        /* -----  Bootstrap Tooltip ----- */
        $('[data-toggle="tooltip"]').tooltip();

        // document.cookie = "useracv=Johnqq; Secure;";
        document.getElementsByClassName('xp-rightbar')[0].style.marginLeft = "0px"
        document.getElementsByClassName('xp-leftbar')[0].style.display = "none"
        document.getElementsByClassName('xp-menubar')[0].style.display = "none"
        document.getElementsByClassName('xp-topbar')[0].style.left = "0"
        document.getElementsByClassName('xp-rightbar')[0].style.marginLeft = "10px"

    }
    getAllLiveUser = () => {
        let _this = this
        GetLiveUsers((ActiveUsers) => {
            _this.setState({ user_active_list: ActiveUsers })

        })
        ReconnectReceiver((Reconnect) => {
            _this.getUnreadUserList()
        })


    }
    msgReceiver = () => {
        let _this = this;
        GetLiveReceiver((DataReceive) => {
            if (DataReceive.error == false) {
                var elem = document.getElementById('msg_history');

                if (DataReceive.event == "GET_UNREAD_USER_LIST") {
                    _this.setState({ latest_msg_list: DataReceive.data })
                } else if (DataReceive.event == "SEND_MESSAGE") {
                    if (DataReceive.chat_type == this.state.selectedUserSection && DataReceive.to_id == this.state.selectedUserId) {
                        _this.state.ActiveChats.push(DataReceive.data[0])
                        _this.setState(_this.state)
                    }
                } else if (DataReceive.event == "GET_USER_MESSAGES") {
                    if (DataReceive.chat_type == this.state.selectedUserSection && DataReceive.to_id == _this.state.selectedUserId) {
                        _this.state.latest_msg_list.find(x => {
                            if (x.from_user_id == DataReceive.to_id) {
                                x.totalUnread = 0
                            }
                        })
                        _this.acknowedge()
                        _this.setState({ ActiveChats: DataReceive.data })
                    }
                } else if (DataReceive.event == "NEW_MESSAGE") {

                    if (DataReceive.chat_type == _this.state.selectedUserSection && DataReceive.from_id == _this.state.selectedUserId) {
                        _this.state.ActiveChats.push(DataReceive.data[0])
                        _this.acknowedge()
                        _this.setState(_this.state)
                    } else {
                        NotificationManager.success(DataReceive.data[0].message, 'New Message Received.')
                        _this.state.latest_msg_list.find(x => {
                            if (x.from_user_id == DataReceive.from_id) {
                                x.totalUnread += 1
                            }
                        })
                        _this.setState(_this.state)
                    }
                }
                setTimeout(() => {
                    if (elem) {
                        elem.scrollTop = elem.scrollHeight;
                    }
                }, 1000)
            } else {

            }
        })
    }
    sendEmit = () => {
        SendEmit({})
    }
    changeUserView = (action) => {
        this.setState({ user_view_by: action })
        if (action == "MESSAGE") {
            this.getUnreadUserList()
        } else if (action == "GROUPBY") {

        }
    }
    handleMsgInput = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }
    msgSend = () => {
        let emitData = {
            from_id: ud.id,
            to_id: this.state.selectedUserId,
            chat_type: "SINGLE",                    // "GROUP"
            message_type: "TEXT",                  // or "TEXT" or "IMAGE" or "AUDIO" or "VIDEO"
            message_text: this.state.msg_txt,
            file: "",
            event: "SEND_MESSAGE",                 // or "GET_UNREAD_USER_LIST" or "GET_USER_MESSAGES" or "ACKNOWLEDGE_MESSAGE" or "REPLY_MESSAGE"
            message_id: null                           // Applicable only with ACKNOWLEDGE_MESSAGE event
        }
        SendEmit(emitData)
        this.setState({ msg_txt: "" })
    }
    getUnreadUserList = () => {
        let emitData = {
            from_id: ud.id,
            to_id: 0,
            chat_type: "SINGLE",                    // "GROUP"
            message_type: "TEXT",                  // or "TEXT" or "IMAGE" or "AUDIO" or "VIDEO"
            message_text: "",
            file: "",
            event: "GET_UNREAD_USER_LIST",                 // or "GET_UNREAD_USER_LIST" or "GET_USER_MESSAGES" or "ACKNOWLEDGE_MESSAGE" or "REPLY_MESSAGE"
            message_id: null                           // Applicable only with ACKNOWLEDGE_MESSAGE event
        }
        SendEmit(emitData)
    }
    acknowedge = () => {
        let emitData = {
            from_id: ud.id,
            to_id: this.state.selectedUserId,
            chat_type: "SINGLE",                    // "GROUP"
            message_type: "TEXT",                  // or "TEXT" or "IMAGE" or "AUDIO" or "VIDEO"
            message_text: "",
            file: "",
            event: "ACKNOWLEDGE_MESSAGE",                 // or "GET_UNREAD_USER_LIST" or "GET_USER_MESSAGES" or "ACKNOWLEDGE_MESSAGE" or "REPLY_MESSAGE"
            message_id: null                           // Applicable only with ACKNOWLEDGE_MESSAGE event
        }
        SendEmit(emitData)
    }
    UserSelect = (list, from) => {
        if (from == "ACTIVE") {
            if (list.user_id != this.state.selectedUserId) {
                this.setState({ ActiveChats: [] })
            }
            this.setState({ selectedUserId: list.user_id, selectedUserSection: "SINGLE" })
            let emitData = {
                from_id: ud.id,
                to_id: list.user_id,
                chat_type: "SINGLE",                    // "GROUP"
                message_type: "TEXT",                  // or "TEXT" or "IMAGE" or "AUDIO" or "VIDEO"
                message_text: "",
                file: "",
                event: "GET_USER_MESSAGES",                 // or "GET_UNREAD_USER_LIST" or "GET_USER_MESSAGES" or "ACKNOWLEDGE_MESSAGE" or "REPLY_MESSAGE"
                message_id: null                           // Applicable only with ACKNOWLEDGE_MESSAGE event
            }
            SendEmit(emitData)
        } else if (from == "MESSAGE") {
            if (list.from_user_id != this.state.selectedUserId) {
                this.setState({ ActiveChats: [] })
            }
            this.setState({ selectedUserId: list.from_user_id, selectedUserSection: "SINGLE" })
            let emitData = {
                from_id: ud.id,
                to_id: list.from_user_id,
                chat_type: "SINGLE",                    // "GROUP"
                message_type: "TEXT",                  // or "TEXT" or "IMAGE" or "AUDIO" or "VIDEO"
                message_text: "",
                file: "",
                event: "GET_USER_MESSAGES",                 // or "GET_UNREAD_USER_LIST" or "GET_USER_MESSAGES" or "ACKNOWLEDGE_MESSAGE" or "REPLY_MESSAGE"
                message_id: null                           // Applicable only with ACKNOWLEDGE_MESSAGE event
            }
            SendEmit(emitData)

        } else if (from == "GROUPBY") {

        }
    }
    render() {
        return (
            <div class="container-chat">
                <h3 class="pull-left btn btn-md btn-info" onClick={() => window.location.href = "/dashboard"}><i class="fa fa-arrow-left"></i> Go To Dashboard</h3>
                <h3 class=" text-center">Messaging</h3>
                <div class="messaging">
                    <div class="inbox_msg">
                        <div class="inbox_people">
                            <div class="headind_srch">
                                <div class="recent_heading">
                                    {this.state.user_view_by === "ACTIVE" ? <h4>All Active Users</h4> : null}
                                    {this.state.user_view_by === "MESSAGE" ? <h4>All Messages</h4> : null}
                                    {this.state.user_view_by === "GROUPBY" ? <h4>All Groups</h4> : null}
                                </div>
                                <div class="srch_bar">
                                    <div class="stylish-input-group">
                                        <input type="text" class="search-bar" placeholder="Search" />
                                        <span class="input-group-addon">
                                            <button type="button"> <i class="fa fa-search" aria-hidden="true"></i> </button>
                                        </span> </div>
                                </div>
                            </div>
                            <div class="inbox_chat">
                                {this.state.user_view_by == "ACTIVE" ?
                                    this.state.user_active_list.map((list, index) =>
                                        list.user_id != ud.id ?
                                            <div onClick={() => this.UserSelect(list, "ACTIVE")} class={`chat_list ${this.state.selectedUserId == list.user_id ? "active_chat" : ""}`}>
                                                <div class="chat_people">
                                                    <div class="chat_img"> <img src={`${SERVER_IP}/icons/${list.profile_picture}`} alt="img" /> </div>
                                                    <div class="chat_ib">
                                                        <h5>{list.user_name} <span class="chat_date">Dec 25</span></h5>
                                                        {/* <p>{list.devices ?
                                                        () => {
                                                            list.devices.includes('WebBrowser') ? <i class="fa fa-window-maximize"></i> : null
                                                            list.devices.includes('Mobile') ? <i class="fa fa-mobile"></i> : null
                                                            list.devices.includes('Realwear') ? <i class="fa fa-simplybuilt"></i> : null

                                                        }
                                                        : null
                                                    } </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    )
                                    : null}
                                {this.state.user_view_by == "MESSAGE" ?
                                    this.state.latest_msg_list.map((list, index) =>
                                        list.from_user_id != ud.id ?
                                            <div onClick={() => this.UserSelect(list, "MESSAGE")} class={`chat_list ${this.state.selectedUserId == list.from_user_id ? "active_chat" : ""}`}>
                                                <div class="chat_people">
                                                    <div class="chat_img"> <img style={{ borderRadius: 100 }} src={`${SERVER_IP}/icons/${list.profile}`} alt="img" /> </div>
                                                    <div class="chat_ib">
                                                        <h5>{list.name} <span class="chat_date">{list.totalUnread == 0 ? "" : <span class="badge badge-secondary">{list.totalUnread}</span>}</span></h5>
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    )
                                    : null}
                                {this.state.user_view_by == "GROUPBY" ?
                                    this.state.grp_msg_list.map((list, index) =>
                                        list.user_id != ud.id ?
                                            <div onClick={() => this.UserSelect(list, "GROUPBY")} class={`chat_list ${this.state.selectedUserId == list.user_id ? "active_chat" : ""}`}>
                                                <div class="chat_people">
                                                    <div class="chat_img"> <img src={`${SERVER_IP}/icons/${list.profile_picture}`} alt="img" /> </div>
                                                    <div class="chat_ib">
                                                        <h5>{list.user_name} <span class="chat_date">Dec 25</span></h5>
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    )
                                    : null}

                            </div>
                            <div className="btn text-center btn-group form-group ">
                                <div className={`btn btn-lg btn-sm ${this.state.user_view_by === "ACTIVE" ? "btn-danger" : "btn-secondary"}`} onClick={() => this.changeUserView("ACTIVE")} >Active Users</div>
                                <div className={`btn btn-lg btn-sm ${this.state.user_view_by === "MESSAGE" ? "btn-danger" : "btn-secondary"}`} onClick={() => this.changeUserView("MESSAGE")} >New Messages</div>
                                <div className={`btn btn-lg btn-sm ${this.state.user_view_by === "GROUPBY" ? "btn-danger" : "btn-secondary"}`} onClick={() => this.changeUserView("GROUPBY")} >Groups</div>

                            </div>
                        </div>
                        <div class="mesgs">
                            {this.state.selectedUserId == 0 ?
                                <>
                                </>
                                :
                                <>
                                    <div class="msg_history" id="msg_history">
                                        {this.state.ActiveChats.map((list, index) =>
                                            list.from_user_id == ud.id ?
                                                <div class="outgoing_msg">
                                                    <div class="sent_msg">
                                                        <p> {list.message} </p> <span class="time_date"> {list.datetime}</span> </div>
                                                </div>

                                                :
                                                <div class="incoming_msg">
                                                    <div class="incoming_msg_img"> <img src="https://ptetutorials.com/images/user-profile.png" alt="img" /> </div>
                                                    <div class="received_msg">
                                                        <div class="received_withd_msg">
                                                            <p>{list.message}</p>
                                                            <span class="time_date"> {list.datetime}</span></div>
                                                    </div>
                                                </div>

                                        )}

                                    </div>
                                    <div class="type_msg">
                                        <div class="input_msg_write">
                                            <input type="text" class="write_msg" name="msg_txt" value={this.state.msg_txt} onChange={this.handleMsgInput} placeholder="Type a message" />
                                            <button class="msg_send_btn" onClick={this.msgSend} type="button"><i class="fa fa-paper-plane-o" aria-hidden="true"></i></button>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <NotificationContainer />
            </div>
        )
    }
}
export default Chat
